import logoFull from "../assets/logo-templo.png";
import logoCompact from "../assets/logo-templo-compact.png";

// Logo oficial Templo | Jiu-Jitsu Culture.
// - compact: versão só do telhado + "TEMPLO" (usada na barra de navegação);
//   quando false, versão completa com a linha "JIU JITSU CULTURE" (rodapé).
// - tone: a arte é escura sobre fundo transparente. Em superfícies claras
//   (tone="dark") ela aparece como está; sobre o hero escuro (tone="light")
//   um filtro CSS a torna branca pra continuar legível nos dois fundos.
export const Logo = ({ compact = false, tone = "dark", className = "" }) => {
  const src = compact ? logoCompact : logoFull;
  const filter = tone === "light" ? "brightness(0) invert(1)" : "none";
  return (
    <img
      src={src}
      alt="Templo | Jiu-Jitsu Culture"
      data-testid="templo-logo"
      draggable="false"
      style={{ filter }}
      className={`${compact ? "h-11" : "h-12"} w-auto select-none shrink-0 ${className}`}
    />
  );
};
